var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "left-arrow-a",
    d: "M16.5625,0 L30,13.4375 L16.5625,26.875 L6.875,26.875 L17.107,16.875 L0,16.875 L0,10 L17.108,10 L6.875,0 L16.5625,0 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 0 41)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#151515",
    points: "0 1 40 1 40 41 0 41",
    transform: "matrix(-1 0 0 1 40 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 34.375 7.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "left-arrow-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#left-arrow-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#151515",
    xlinkHref: "#left-arrow-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF308",
    mask: "url(#left-arrow-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(-5.625 -7.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollLeftArrow);
export default __webpack_public_path__ + "static/media/scroll-left-arrow.25b01e83565436d941770c7b82370a2b.svg";
export { ForwardRef as ReactComponent };